namespace ekh {

    class ValidateCvvTokenErrors {
        private paymentForm: ng.IFormController;

        constructor(private $scope: ng.IScope) {
            $scope.$watch('validateCvvCtrl.tokenErrors', (tokenErrors) => {
                if (!this.paymentForm || !this.paymentForm.securityCode) {
                    return false;
                }
                if (!tokenErrors || !Object.keys(tokenErrors).length) {
                    $scope.ngModelCvvCtrl.$setViewValue('***');
                    this.paymentForm.securityCode.$setValidity('validCvvCode', true);
                } else {
                    $scope.ngModelCvvCtrl.$setViewValue();
                    this.paymentForm.securityCode.$setValidity('validCvvCode', false);
                }
            });
        }
    }

    angular.module('ekh')
        .directive('validateCvvTokenErrors', () => {
            return {
                restrict: 'A',
                require: 'ngModel',
                controllerAs: 'validateCvvCtrl',
                bindToController: {
                    tokenErrors: '=',
                    paymentForm: '='
                },
                controller: ValidateCvvTokenErrors,
                template: '',
                link: ($scope, $element, $attrs, ngModelCtrl) => {
                    $scope.ngModelCvvCtrl = ngModelCtrl;
                }
            };
        });
};
